<script>
import Notifications from "./Notifications";

import { mapActions, mapState } from "vuex";
import ClickOutside from "vue-click-outside";

export default {
  data() {
    return {
      showNotifications: false
    };
  },

  components: {
    Notifications
  },

  directives: {
    ClickOutside
  },

  computed: {
    ...mapState("sidebar", ["opened"])
  },

  methods: {
    ...mapActions("sidebar", ["setOpened"]),

    toggleNotifications(event, val) {
      this.showNotifications = val;
      event.stopPropagation();
    },

    outside() {
      this.showNotifications = false;
    }
  }
};
</script>

<template>
  <div class="navbar">
    <div class="burguer" @click="setOpened(!opened)">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <!---
    <div class="menu">
      <div class="icon notify" @click="toggleNotifications($event, !showNotifications)">
        <span>100</span>
      </div>
      <div class="icon messages">
        <span>3</span>
      </div>
      <div class="icon profile">
        <span>10</span>
      </div>
    </div>
    -->

    <transition name="down" mode="in-out">
      <Notifications v-click-outside="outside" v-show="showNotifications" />
    </transition>
  </div>
</template>

<style scoped>
.navbar {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.navbar .burguer {
  cursor: pointer;
}

.navbar .burguer span {
  display: block;
  width: 28px;
  height: 3px;
  margin-bottom: 5px;
  background-color: #a6a6a6;
}

.navbar .menu {
  display: flex;
  height: 100%;
}

.navbar .menu .icon {
  width: 50px;
  height: 100%;
  background-size: 18px 18px;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  cursor: pointer;
  transition: all 0.25s ease;
}

.navbar .menu .icon:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.navbar .menu .icon span {
  position: absolute;
  top: 10px;
  font-size: 8px;
  background-color: var(--red);
  color: #fff;
  font-weight: 700;
  border-radius: 4px;
  padding: 3px 5px;
}

.navbar .menu .icon.notify {
  background-image: url("../../static/notify.svg");
}

.navbar .menu .icon.messages {
  background-image: url("../../static/messages.svg");
}

.navbar .menu .icon.profile {
  background-image: url("../../static/profile.svg");
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue